webpackJsonp([123551693136459],{

/***/ 390:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>WIP: This page will describe the new Remote Control feature (and its limitations).</p>","frontmatter":{"path":"/SF2RemoteControl","title":"SubFire 2 Remote Control Features","summary":"The Mobile-Friendly Subsonic Client"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---sf-2-remote-control-720fb636fbd6b95a2ea3.js